import { render, staticRenderFns } from "./AccountingMarketingObjectsView.vue?vue&type=template&id=6546c23c&scoped=true"
import script from "./AccountingMarketingObjectsView.vue?vue&type=script&lang=js"
export * from "./AccountingMarketingObjectsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6546c23c",
  null
  
)

export default component.exports